<wsb-modal
  (close)="activeModal.close()"
  (dismiss)="activeModal.dismiss()"
  [title]="template?.name"
  extraFooterClasses="modal-footer-right-buttons"
>
  <div body>
    <textarea class="form-control preview-textarea" disabled [value]="template?.text" rows="6"></textarea>
  </div>

  <div footer class="d-flex">
    <wsb-atlas-button
      [roundButton]="false"
      variant="primary"
      label="common_use"
      size="sm"
      class="me-3"
      (btnClick)="sendSmsTemplate()"
    ></wsb-atlas-button>
    <wsb-atlas-dropdown
      [hidden]="template?.sharingInfo"
      [label]="'common_actions'"
      variant="secondary dropdown-toggle"
      size="sm"
      class="me-5"
      [roundButton]="false"
    >
      <button ngbDropdownItem translate (click)="openSmsTemplateEditModal()">common_edit</button>
      <button ngbDropdownItem translate (click)="deleteTemplate()">common_delete</button>
    </wsb-atlas-dropdown>
    <wsb-atlas-button [roundButton]="false" variant="link" label="cancel" size="sm" (btnClick)="activeModal.dismiss()"></wsb-atlas-button>
  </div>
</wsb-modal>

<ng-template #deleteTemplateConfirmModal let-c="close" let-d="dismiss">
  <wsb-modal
    (primary)="deleteTemplateConfirm()"
    (dismiss)="d()"
    primaryButtonText="common_ok"
    cancelButtonEnable="true"
    title="{{ 'common_attention' | translate }}"
    text="{{ 'sms_template_delete_confirm' | translate }}"
  ></wsb-modal>
</ng-template>
